import { NCDIPO, NCDIPO_ADD_MSG, NCDIPO_CLEAR_MSG, NCDIPO_ERROR, NCDIPO_HIDE_ERROR, NCDIPO_START_LOADER, NCDIPO_STOP_LOADER, } from "../interface/iNCDIPO";
const initState = {
    data: {
        liveNcdIpo: [],
        upcomingNcdIpo: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: "",
    },
};
const NCDIPOReducer = (state = initState, action) => {
    switch (action.type) {
        case NCDIPO:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case NCDIPO_ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case NCDIPO_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case NCDIPO_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case NCDIPO_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case NCDIPO_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case NCDIPO_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default NCDIPOReducer;
